"use client";

import PWAInstallHandler from "@/shared/components/common/pwa-install-handler";

export default function PWAInstallGate() {
  // Show on all pages for browser users
  return <PWAInstallHandler />;
}
